import { CombinedError } from 'urql';

export const isCombinedError = (error: unknown): error is CombinedError => {
  return error instanceof CombinedError;
};
